export const AUTH = {
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  submitBtn: "auth-submit-btn",
  logoutBtn: "auth-logout-btn",
  errorMsg: "auth-error-msg",
};

export const NAV = {
  sidebar: "app-sidebar",
  home: "nav-home",
  approvals: "nav-approvals",
  exceptions: "nav-exceptions",
  employees: "nav-employees",
  companies: "nav-companies",
  requests: "nav-requests",
  assets: "nav-assets",
  deployDevice: "nav-deploy-device",
  offboarding: "nav-offboarding",
  shipments: "nav-shipments",
  pickups: "nav-pickups",
  warehouse: "nav-warehouse",
  inspection: "nav-inspection",
  dataErasure: "nav-data-erasure",
  itad: "nav-itad",
  catalogue: "nav-catalogue",
  service: "nav-service",
  users: "nav-users",
  audit: "nav-audit",
  services: "nav-services",
  profileMenu: "nav-profile-menu",
  searchInput: "nav-search-input",
};

export const DASH = {
  kpiTotal: "kpi-total-assets",
  kpiInUse: "kpi-in-use",
  kpiAvailable: "kpi-available",
  kpiInTransit: "kpi-in-transit",
  kpiUnderRepair: "kpi-under-repair",
  kpiPendingApprovals: "kpi-pending-approvals",
  kpiOpenRequests: "kpi-open-requests",
  kpiWarrantyExpiring: "kpi-warranty-expiring",
};

export const ASSET = {
  table: "asset-table",
  row: (id) => `asset-row-${id}`,
  drawer: "asset-drawer",
  drawerClose: "asset-drawer-close",
  timelineTab: "asset-tab-timeline",
  overviewTab: "asset-tab-overview",
  historyTab: "asset-tab-history",
  searchInput: "asset-search-input",
  filterLifecycle: "asset-filter-lifecycle",
  filterCondition: "asset-filter-condition",
};

export const DEPLOY = {
  stepMasterCo: "deploy-step-master-co",
  stepEmployee: "deploy-step-employee",
  stepDevice: "deploy-step-device",
  stepServices: "deploy-step-services",
  stepReview: "deploy-step-review",
  submitBtn: "deploy-submit-btn",
  nextBtn: "deploy-next-btn",
  backBtn: "deploy-back-btn",
  employeeSelect: "deploy-employee-select",
  deviceSearch: "deploy-device-search",
  deviceItem: (id) => `deploy-device-item-${id}`,
};

export const REQ = {
  table: "requests-table",
  row: (id) => `request-row-${id}`,
  approveBtn: "request-approve-btn",
  rejectBtn: "request-reject-btn",
};

export const SHIP = {
  table: "shipments-table",
  row: (id) => `shipment-row-${id}`,
  statusBtn: "shipment-status-btn",
};

export const PICKUP = {
  table: "pickups-table",
  row: (id) => `pickup-row-${id}`,
  statusBtn: "pickup-status-btn",
};

export const INSP = {
  form: "inspection-form",
  submitBtn: "inspection-submit-btn",
  gradeSelect: "inspection-grade-select",
  assetSelect: "inspection-asset-select",
};

export const ERASE = {
  startBtn: "erasure-start-btn",
  verifyBtn: "erasure-verify-btn",
  downloadCert: "erasure-download-cert",
  assetSelect: "erasure-asset-select",
};

export const ITAD_IDS = {
  createBtn: "itad-create-btn",
  completeBtn: "itad-complete-btn",
  dispositionSelect: "itad-disposition-select",
};

export const HOME = {
  emergentLink: "home-emergent-link",
};
